import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { DoorType } from '../models/door-type';

@Injectable({
  providedIn: 'root'
})
export class DoorTypeService extends BaseService<DoorType> {

  constructor(
    http: HttpClient,
    @Inject('BASE_URL') rootUrl: string            
  ) { 
    super(http,rootUrl,'Plasard/PlasardDoorType');
  }
}
